import { PageKey } from "@apis:ui_branding/ui_branding";
import { TFunction } from "i18next";

export const getPageLabel = (page: PageKey, t: TFunction): string =>
  t(`preferences.uiBranding.pageLabels.${page}`);
